__turbopack_context__.v({
  "PageListPage__Container": "HtqN6q_PageListPage__Container",
  "PageListPage__List": "HtqN6q_PageListPage__List",
  "PageListPage__Pagination": "HtqN6q_PageListPage__Pagination",
});
